import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/care_link_worker/care_link_worker/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/care_link_worker/care_link_worker/src/components/ui/elements/index.ts");
